import $ from 'jquery';
import ProductDetails from '../snippets/ProductDetails';

import ProductMenu from '../snippets/ProductMenu';

export default class Product {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    const onboarding = section.data.onboarding;

    // Product details
    this.productDetails = new ProductDetails(this.$el, section);

    // Product menu
    if (!onboarding && !this.section.data.form_is_inline) {
      this.productMenu = new ProductMenu(section.el.querySelector('[data-product-menu]'), this.section.data, this.section.postMessage);
    }
  }

  onSectionMessage(name, data) {
    if (this.productMenu) {
      this.productMenu.onSectionMessage(name, data);
    }
  }

  onSectionUnload() {
    if (this.productMenu) this.productMenu.unload();
    this.productDetails.unload();
  }
}
